import React, { useEffect } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { Layout } from './Layout';
import { InquiryDetailHeader } from '../organisms/InquiryDetailHeader';
import { useRootStore } from '../../App';
import { ChatHeader } from '../organisms/ChatHeader';
import { ChatDetail } from '../organisms/ChatDetail';
import { ChatInputForm } from '../organisms/ChatInputForm';
import { PreviewModal } from '../organisms/PreviewModal';
import ClearFixStyle from '../atoms/ClearFixStyle';
import { Loader } from '../atoms';

const StyledDiv = styled.div`
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `${ClearFixStyle} width: 85vw;`
      : 'display: flex;flex-direction: column;flex-grow: 1;'}
`;

export const InquiryDetailPage = observer(() => {
  const root = useRootStore();
  const { emitWatchingState } = root.socketStore;

  useEffect(() => {
    emitWatchingState('focus'); // for page rendering

    window.addEventListener('visibilitychange', function () {
      document.hidden ? emitWatchingState('blur') : emitWatchingState('focus');
    });
  }, [emitWatchingState]);

  if (
    !(
      root.inquiryPageStore.isStoresReadyToRender &&
      root.inquiryStore.isInquiryReady
    )
  ) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }
  const { isWide } = root.layoutStore;
  // const { showNotFoundContent } = root.inquiryPageStore;
  const { isModalVisible } = root.previewModalStore;
  const { sortedAutoMessages } = root.faqStore;

  const { recipients } = root.userStore;
  const { activeInquiry } = root.inquiryStore;
  const { targetDetail } = root.partnerStore!;

  const getIconImageUrl = (): string => {
    if (targetDetail?.hotelImageUrl) {
      return targetDetail.hotelImageUrl;
    } else if (activeInquiry) {
      return activeInquiry.recipients[0].userIcon;
    } else {
      return Array.from(recipients.values())[0].userIcon;
    }
  };

  const iconImageUrl = getIconImageUrl();

  return (
    // show loading icon until messages are ready
    sortedAutoMessages.length > 0 ? (
      <Layout>
        <>
          <InquiryDetailHeader />
          {/* {showNotFoundContent ? (
          <NotFoundContents isWide={isWide} />
        ) : ( */}
          <StyledDiv isWide={isWide}>
            <ChatHeader
              iconImageUrl={
                iconImageUrl + `?fit=inside%7C${isWide ? 200 : 72}:*`
              }
            />
            <ChatDetail
              iconImageUrl={
                iconImageUrl + `?fit=inside%7C${isWide ? 100 : 50}:*`
              }
            />
            <ChatInputForm />
          </StyledDiv>
          {isModalVisible ? <PreviewModal /> : null}
          {/* )} */}
        </>
      </Layout>
    ) : (
      <Layout>
        <Loader />
      </Layout>
    )
  );
});
